module.exports = __webpack_public_path__ + "static/media/u2u.5ecd58a2.png";